// API ka base URL. Swagger pe jo tha (https://localhost:7112) wahi.
// export const environment = {
//     production: false,
//     apiUrl: 'http://localhost:5183/api',
//     serverUrl: 'http://localhost:5183'
// };
export const environment = {
    production: true,
    apiUrl: '/api', // poora URL nahi, sirf /api
    serverUrl: '' // khali - same domain se images bhi
};
